<template>
    <v-alert v-if="ehPerfilComprador && !ehCompradorComPermissao" :value="true" color="#fff3cd" icon="priority_high" style="color: #664d03">
        Você possui permissão apenas para visualizar mensagens. Não é permitido enviar mensagens.
    </v-alert>
    <v-form ref="form" v-else>
        <v-textarea v-if="deveHabilitarChatParaUsuarioOnline"
                    outline class="textarea-mensagem pr-5" name="Mensagem"
                    placeholder="Escrever mensagem..."
                    v-model="mensagem" rows="2"
                    key="Mensagem"
                    :max-rows="5"
                    :auto-grow="growRowsComputed < 3"
                    @keyup.enter.prevent="enviarMensagem"
                    @keyup.delete="processarDeleteText">
            <template v-slot:append-outer>
                <v-btn icon fab small type="submit" color="secondary" class="button-send-mensagem" @click.prevent="enviarMensagem">
                    <svg class="icon-send-message" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>send-outline</title>
                        <path d="M4 6.03L11.5 9.25L4 8.25L4 6.03M11.5 14.75L4 17.97V15.75L11.5 14.75M2 3L2 10L17 12L2 14L2 21L23 12L2 3Z" />
                    </svg>
                </v-btn>
            </template>
        </v-textarea>
        <v-alert v-else-if="ehPerfilComprador" :value="true" color="#fff3cd" icon="priority_high" style="color: #664d03">
            Não é possível enviar mensagens, pois este fornecedor não é o vencedor atual do Item/Lote.
        </v-alert>
        <v-alert v-else :value="true" color="#fff3cd" icon="priority_high" style="color: #664d03">
            Não é possível enviar mensagens, pois o(a) Sr.(a) não é o/a vencedor(a) atual do Item/Lote.
        </v-alert>
    </v-form>
</template>

<script>
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import { mapState } from 'vuex'

export default {
    name: 'AcoesEnviarMensagem',
    props: {
        itemOuLote: {
            type: Object,
            default: () => ({
                ranking: []
            })
        },
        usuarioOnline: {
            type: Object,
            required: true
        },
        ehPerfilComprador: {
            type: Boolean,
            required: true
        },
        destinatario: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            mensagem: null
        }
    },
    computed: {
        ...mapState(['loki']),
        growRowsComputed(){
            if(!this.mensagem) return 0
            return Math.floor(this.mensagem.length / 70) + (this.mensagem.match(/[\r\n|\r|\n]/g) || []).length
        },
        deveHabilitarChatParaUsuarioOnline(){
            if(this.ehPerfilComprador){
                const fornecedor = this.itemOuLote.ranking.find(r => r.pessoaId === this.destinatario.id)
                return fornecedor && ['EM_ANALISE', 'ADJUDICADO'].includes(fornecedor.status)
            }

            const ranking = this.itemOuLote.ranking.find(r => r.situacaoFornecedor === 'EM_ANALISE')

            if(ranking)
                return (ranking.pessoaId === this.usuarioOnline.dominioId)
            return false
        },
        ehCompradorComPermissao(){
            return azAuth(this.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
        }
    },
    methods: {
        enviarMensagem(event) {
            if(this.mensagem && this.mensagem.trim().length >= 2 ){
                this.$emit('enviarMensagem', this.mensagem)

                this.mensagem = ''
                event.target.value = ''

                this.processarDeleteText(event)
            }
        },

        processarDeleteText(event){
            const text = event.target.value.trim()
            if(text.length <= 0)
                event.target.style.height = '33px'
        }
    }
}
</script>

<style scoped lang="stylus">
    .icon-send-message
        fill  white !important
        height 20px

    .textarea-mensagem
        position relative

    .button-send-mensagem
        position absolute
        right 0
        bottom 30px
</style>